<template>
    <div>
        <el-upload
                :disabled="!isedit"
                :class="{disabled:(!isedit||fileList.length==1)}"

                :action="action"
                list-type="picture-card"
                :before-upload="beforeAvatarUpload"
                :on-preview="handlePictureCardPreview"
                :file-list="fileList"
                :on-change="handleChange"
                :on-exceed="handleExceed"
                :limit="1"
                :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>


</template>

<script>
    export default {
        props: {
            isedit: Boolean,
            action: String
        },
        name: "UploadImg",
        data() {
            return {
                dialogImageUrl: '',
                dialogVisible: false,
                fileList: [],
            }
        },
        mounted() {

        },
        methods: {
            handleRemove(file, fileList) {
                this.fileList = fileList;
                this.form.picname = '';
                this.form.picurl = '';

                this.$emit('changeImg', {
                    fileList: fileList,
                    picname: '',
                    picurl: '',
                })
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择1 个文件`);
            },
            handleChange(file, fileList) {
                let picurl = '';
                let picname = '';
                picname = file.name;
                if (file.response) {
                    picurl = file.response.imgurl;
                }

                this.fileList = fileList;

                this.$emit('change', {
                    fileList: fileList,
                    picname: picname,
                    picurl: picurl,
                })
            },
            beforeAvatarUpload(file) {

                const isJPG = file.type === 'image/jpeg';
                const isPng = file.type === 'image/png';
                if (isJPG || isPng) {
                } else {
                    this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
                }
                return isJPG || isPng;
            }

        }
    }
</script>

<style scoped>

</style>